import { useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'

export const useGenreStats = () => {
  const { colors } = useTheme()
  const [theme, stats] = useStats((s) => [s.theme, s.stats])
  const genreStats = stats?.genres?.results || []

  const colorKeys = [
    theme.primary,
    colors.uiWhite,
    colors.uiWhite50,
    colors.uiWhite20,
    theme.accent,
  ]

  const statsList = genreStats?.map((g) => ({
    id: g.name.toLowerCase().replace(' ', '-'),
    label: g.name,
    value: g.count,
    color: colorKeys[genreStats.indexOf(g)],
  }))

  return statsList
}
